import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class SmartOfferBundleTreasureType extends Cloneable {
    static NONE = new SmartOfferBundleTreasureType(0, "NONE");

    static _values = [
        new SmartOfferBundleTreasureType(1, "TREASURE_HUNT")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, SmartOfferBundleTreasureType.getValue(id));
        });
    }

    static is(value) {
        if (value instanceof SmartOfferBundleTreasureType) {
            return SmartOfferBundleTreasureType._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return SmartOfferBundleTreasureType.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    equal(value) {
        if (value instanceof SmartOfferBundleTreasureType) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTreasureType());
        } else if (target instanceof SmartOfferBundleTreasureType) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTreasureType, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});